export interface Category {
  slug: string;
  name: string;
  shortName: string;
  description: string;
  metaTitle: string;
  metaDescription: string;
  icon: string;
  heroText: string;
  brands: string[];
}

export const categories: Category[] = [
  {
    slug: "plc",
    name: "Programmable Logic Controllers (PLC)",
    shortName: "PLCs",
    description: "Shop new industrial PLCs from top manufacturers. ControlLogix, CompactLogix, SIMATIC S7-1200, S7-1500, S7-300, and more — in stock and ready to ship.",
    metaTitle: "Buy PLC Controllers | Allen Bradley, Siemens | Nardy Automation",
    metaDescription: "New PLC controllers from Allen Bradley, Siemens, Schneider Electric. ControlLogix, SIMATIC S7-1200, S7-1500 in stock. Ships worldwide.",
    icon: "🔧",
    heroText: "Industrial PLC controllers for every automation application — Allen-Bradley & Siemens platforms.",
    brands: ["Allen Bradley", "Siemens", "Mitsubishi Electric", "Schneider Electric", "Delta Electronics", "IDEC", "WAGO", "IFM"],
  },
  {
    slug: "hmi",
    name: "Human Machine Interfaces (HMI)",
    shortName: "HMIs",
    description: "Touchscreen HMI panels and operator interfaces. PanelView, Siemens Comfort Panels, and industrial displays for factory floor control.",
    metaTitle: "Buy HMI Panels & Touchscreens | Allen Bradley, Siemens | Nardy Automation",
    metaDescription: "Industrial HMI touchscreens. Allen Bradley PanelView, Siemens Comfort & Basic Panels in stock. Ships worldwide.",
    icon: "🖥️",
    heroText: "High-performance touchscreen interfaces from Allen-Bradley and Siemens for real-time machine monitoring.",
    brands: ["Allen Bradley", "Siemens", "Mitsubishi Electric", "Delta Electronics", "Pro-face", "Schneider Electric", "FANUC", "Videojet"],
  },
  {
    slug: "vfd",
    name: "Variable Frequency Drives (VFD)",
    shortName: "VFDs",
    description: "AC & DC variable frequency drives for motor speed control. PowerFlex, SINAMICS G120, V20, and industrial inverters.",
    metaTitle: "Buy VFD Drives | PowerFlex, SINAMICS | Nardy Automation",
    metaDescription: "Variable frequency drives. Allen Bradley PowerFlex, Siemens SINAMICS G120, V20. New VFDs in stock. Ships worldwide.",
    icon: "⚡",
    heroText: "Precision motor control with variable frequency drives from Allen-Bradley and Siemens.",
    brands: ["Allen Bradley", "Siemens", "Mitsubishi Electric", "Delta Electronics", "Lenze", "SEW Eurodrive", "Rexroth", "Schneider Electric"],
  },
  {
    slug: "servo-drives",
    name: "Servo Drives & Motors",
    shortName: "Servo Drives",
    description: "High-precision servo drives and servo motors. Kinetix, SINAMICS S120, S210, SIMODRIVE 611 for CNC, robotics, and motion control.",
    metaTitle: "Buy Servo Drives & Motors | Kinetix, SINAMICS S120 | Nardy Automation",
    metaDescription: "Servo drives & motors. Allen Bradley Kinetix, Siemens SINAMICS S120, SIMODRIVE. In stock. Ships worldwide.",
    icon: "🔄",
    heroText: "Precision servo systems from Allen-Bradley Kinetix and Siemens SINAMICS for high-speed positioning.",
    brands: ["Allen Bradley", "Siemens", "Mitsubishi Electric", "Delta Electronics", "FANUC", "Rexroth", "Lenze", "SEW Eurodrive"],
  },
  {
    slug: "power-supplies",
    name: "Industrial Power Supplies",
    shortName: "Power Supplies",
    description: "DIN-rail and rack-mount power supplies. Allen-Bradley 1606, Siemens SITOP, and industrial DC power for automation racks.",
    metaTitle: "Buy Industrial Power Supplies | Allen Bradley, Siemens SITOP | Nardy Automation",
    metaDescription: "Industrial power supplies. Allen Bradley 1606, Siemens SITOP PSU8200/6200. DIN-rail mount, in stock. Ships worldwide.",
    icon: "🔋",
    heroText: "Reliable industrial power supplies from Allen-Bradley and Siemens for automation racks and control panels.",
    brands: ["Allen Bradley", "Siemens", "Delta Electronics", "IDEC", "WAGO", "Schneider Electric", "Bussmann"],
  },
  {
    slug: "sensors-instrumentation",
    name: "Sensors & Instrumentation",
    shortName: "Sensors",
    description: "Industrial sensors, transmitters, and instrumentation for process control.",
    metaTitle: "Buy Industrial Sensors | IFM, Endress+Hauser | Nardy Automation",
    metaDescription: "Industrial sensors & instrumentation from IFM, Endress+Hauser, Videojet. Proximity sensors, transmitters in stock.",
    icon: "📡",
    heroText: "Precision industrial sensors and instrumentation for process monitoring.",
    brands: ["IFM", "Endress+Hauser", "Videojet", "Allen Bradley", "Siemens", "Schneider Electric"],
  },
  {
    slug: "motion-control",
    name: "Motion Control & Servo Motors",
    shortName: "Motion Control",
    description: "Servo motors, CNC cables, gearboxes, and motion control components. Allen-Bradley MPL/VPL, Siemens SIMOTICS, and more.",
    metaTitle: "Buy Servo Motors & Motion Control | Nardy Automation",
    metaDescription: "Servo motors & motion control. Allen Bradley MPL, Siemens SIMOTICS 1FK7, CNC cables, gearboxes in stock.",
    icon: "⚙️",
    heroText: "Industrial servo motors and motion control solutions from Allen-Bradley and Siemens.",
    brands: ["Allen Bradley", "Siemens", "Mitsubishi Electric", "Delta Electronics", "SEW Eurodrive", "Lenze", "Rexroth", "FANUC"],
  },
  {
    slug: "industrial-components",
    name: "Industrial Components & Control",
    shortName: "Components",
    description: "Contactors, soft starters, motor protection, push buttons, safety relays. Allen-Bradley and Siemens SIRIUS switching portfolio.",
    metaTitle: "Buy Industrial Components | Allen Bradley, Siemens SIRIUS | Nardy Automation",
    metaDescription: "Industrial components. Allen Bradley, Siemens SIRIUS contactors, soft starters, safety relays, push buttons in stock.",
    icon: "🔩",
    heroText: "Essential industrial components — Allen-Bradley and Siemens SIRIUS switching and protection devices.",
    brands: ["Allen Bradley", "Siemens", "Mitsubishi Electric", "Bussmann", "WAGO", "Schneider Electric", "IDEC"],
  },
  {
    slug: "industrial-computing",
    name: "Industrial Computing, CNC & Networking",
    shortName: "Industrial PCs & CNC",
    description: "CNC controllers, industrial computers, managed switches, and networking. Siemens SINUMERIK, SCALANCE, Allen-Bradley Stratix.",
    metaTitle: "Buy CNC Controllers & Industrial Networking | Nardy Automation",
    metaDescription: "Siemens SINUMERIK CNC, SCALANCE switches, Allen Bradley Stratix. Industrial networking in stock. Ships worldwide.",
    icon: "💻",
    heroText: "CNC controllers, industrial networking, and computing solutions from Siemens and Allen-Bradley.",
    brands: ["Siemens", "Allen Bradley", "FANUC", "WinSystems", "Morse", "Schneider Electric"],
  },
  {
    slug: "pneumatics-hydraulics",
    name: "Pneumatics & Hydraulics",
    shortName: "Pneumatics",
    description: "Pneumatic valves, cylinders, hydraulic components, and fluid power systems.",
    metaTitle: "Buy Pneumatic & Hydraulic Components | Nardy Automation",
    metaDescription: "Pneumatic valves, cylinders, and hydraulic components. Industrial fluid power in stock.",
    icon: "🔧",
    heroText: "Industrial pneumatic and hydraulic components for precise force control.",
    brands: ["BLH", "Rexroth", "Schneider Electric", "WAGO", "IFM", "Endress+Hauser"],
  },
];
